<section class="section md__columns-auto margin__bottom" *ngFor="let block of blocks">
  <div class="module__text" [innerHTML]="block.wysivyg" *ngIf="block.wysivyg"
    [ngClass]="(block.image) ? 'has__assets' : 'container container__md'"></div>
  <figure class="module__background" *ngIf="block.image">
    <img class="img-responsive" src="{{block.image.sizes.content}}"
      alt="{{block.image.description ? block.image.description : 'Bilde'}}" />
  </figure>
</section>
